import { jwtInterceptor } from './jwt.interceptor';
import { errorInterceptor } from './error.interceptor';
import { timeoutInterceptor } from './timeout.interceptor';

export const interceptors = [
  jwtInterceptor,
  timeoutInterceptor,
  errorInterceptor
];